
import { defineComponent, ref, watch } from 'vue'
import { FormDataStructure } from '@/contracts/forms/FieldContracts'
import { NuxeoActivationResponse } from '@/contracts/api/ResponseContracts'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import Heading from '@/components/Heading.vue'
import Form from '@/components/Form.vue'
import { nuxeoActivation } from '@/composables/nuxeo'

export default defineComponent(
{
    name: 'RegisterActivate',
    components:
    {
        Heading,
        Form
    },
    setup()
    {
        // Load router:
        const router = useRouter()
        const route = useRoute()
        // Load vuex:
        const store = useStore()
        // Hold docid:
        const docid = ref('')
        if(route.query.g !== undefined && typeof route.query.g === 'string')
        {
            docid.value = route.query.g
        }
        // Hold status:
        const passwordStatus = ref(false)
        // Set fields:
        const fields =
        {
            password:
            {
                name: 'password',
                type: 'Input',
                label: 'Password',
                hint: 'Password must contain at least one lowercase letter, one uppercase letter, one special character, at least one digit and a minimum of 8 characters long.',
                inputType: 'password',
                width: 'govuk-input--width-20',
                rules:
                {
                    required:
                    {
                        config: true
                    },
                    password:
                    {
                        config: true
                    }
                }
            },
            passwordconfirm:
            {
                name: 'passwordconfirm',
                type: 'Input',
                label: 'Confirm password',
                hint: 'Please confirm your password',
                inputType: 'password',
                width: 'govuk-input--width-20',
                rules:
                {
                    required:
                    {
                        config: true
                    },
                    confirm:
                    {
                        config: 'password'
                    }
                }
            }
        }
        // Set buttons:
        const buttons =
        {
            submit:
            {
                name: 'submit',
                type: 'Submit',
                text: 'Activate account'
            }
        }
        // Handle submission:
        const saveFormData = (formData: FormDataStructure) =>
        {
            nuxeoActivation(
            {
                docid: docid.value,
                password: formData.password
            },
            function(response: NuxeoActivationResponse)
            {
                // Show success:
                store.commit('confirmations/setConfirmationData',
                {
                    title: 'Account created',
                    body: 'Your account has successfully been created. Please click the Sign In button to login.'
                })
                router.push({ hash: '#confirmation-summary-container' })
                passwordStatus.value = true
            })
        }

        // Return data:
        return {
            docid,
            fields,
            buttons,
            saveFormData,
            passwordStatus
        }
    }
})
